import {useNavigate, useRouteError} from 'react-router-dom'
import {VmoErrorPage} from 'vmo-library'

export default function GeneralError() {
  const navigate = useNavigate()
  const error = useRouteError()

  const onClickHome = () => navigate('/')

  if (error) {
    if (error.statusCode === 404) {
      return <VmoErrorPage onClick={onClickHome} heading={404} />
    }
    if (error.statusCode === 403) {
      return (
        <VmoErrorPage
          onClick={onClickHome}
          heading="403 - Unauthorized"
          subheader="You aren't authorized to see this page."
        />
      )
    }

    if (error.statusCode === 401) {
      return <VmoErrorPage onClick={onClickHome} heading="You aren't authorized to see this" />
    }

    if (error.statusCode === 503) {
      return <VmoErrorPage onClick={onClickHome} heading="Looks like our API is down" />
    }

    if (error.statusCode === 418) {
      return <div>🫖</div>
    }
  }

  return (
    <>
      <VmoErrorPage
        onClick={onClickHome}
        heading="Sorry, the page is not found!"
        subheader="The page you are looking for does not exist or has been moved"
        btnLabel="Go to Homepage"
      />
    </>
  )
}
